export default "__VITE_ASSET__CzuZBPbZ__"